// src/pages/admin/SiteFooter.tsx
"use client";
import SiteFooter from "../../components/admin/SiteFooter";

export default function SiteFooterPage() {
  return (
    <div className="p-6">
      <SiteFooter />
    </div>
  );
}
